import React from 'react';
import styled from 'styled-components';

const EmptyStateContainer = styled.div`
  text-align: center;
  padding: 40px;
  background-color: white;
  border-radius: ${props => props.theme.borderRadius};
  box-shadow: ${props => props.theme.shadows.small};
`;

const EmptyStateIcon = styled.div`
  font-size: 40px;
  margin-bottom: 20px;
  color: ${props => props.theme.colors.secondary};
`;

const EmptyStateText = styled.p`
  font-size: 16px;
  color: ${props => props.theme.colors.secondary};
  margin-bottom: 20px;
`;

const ActionButton = styled.button`
  display: inline-block;
`;

function EmptyState({ icon, message, actionText, onAction }) {
  return (
    <EmptyStateContainer>
      <EmptyStateIcon>{icon || '🎬'}</EmptyStateIcon>
      <EmptyStateText>{message}</EmptyStateText>
      {actionText && onAction && (
        <ActionButton onClick={onAction}>
          {actionText}
        </ActionButton>
      )}
    </EmptyStateContainer>
  );
}

export default EmptyState; 